import Component from './ProfileSettings.vue';

export default Component;
